(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Agreements.MasterAdvisorAgreement",
                {
                    url: "/MasterAdvisorAgreement",
                    component: "masteradvisoragreement",
                    PageTitle: "Master Advisor Agreement",
                    //requiredPermissions: "Agreements:View",      
                    resolve: {
                        //masterAdvisorAgreementSignatureRequiredModel: ["agreementsApi", function (agreementsApi) {
                        //    return agreementsApi.getMasterAdvisorAgreementRequiredModel().then(function (model) {
                        //        return model;
                        //    });
                        //}],
                        //masterAdvisorAgreements: ["agreementsApi", function (agreementsApi) {
                        //    return agreementsApi.getLoggedInUserMasterAdvisorAgreements().then(function (agreements) {
                        //        return agreements;
                        //    });
                        //}]
                    }
                });
        }
    ]);

    app.component("masteradvisoragreement",
        {
            templateUrl: "App/Agreements/MasterAdvisorAgreement/MasterAdvisorAgreement.html",
            controller: masterAdvisorAgreementCtrl,
            bindings: {   
                masterAdvisorAgreementSignatureRequiredModel: "<",
                masterAdvisorAgreements: "<"
            }
        });

    masterAdvisorAgreementCtrl.$inject = ["$http", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "permissionService", "agreementsApi", "$window", "$location", "$state", "$q", "$scope"];

    function masterAdvisorAgreementCtrl($http, eligibilityFormDialog, surveys, eligibilityFormApi, permissionService, agreementsApi, $window, $location, $state, $q, $scope) {
        var $ctrl = this;
        window.o = this;
        function init() {

            $ctrl.UI = {};
            $ctrl.docIsigned = false;
            $ctrl.envelopeId = $location.search().envelopeId;

            if ($location.search().test != null) {
                $ctrl.UI.testing = true;
                $ctrl.UI.optedOut = permissionService.getOptOutMasterAdvisorAgreement() ? true : false;
                $ctrl.UI.needsToSign = $ctrl.masterAdvisorAgreementSignatureRequiredModel === null ? false : true;
                console.log($ctrl.masterAdvisorAgreements);
            }

            if (permissionService.getOptOutMasterAdvisorAgreement() === null &&
                $ctrl.masterAdvisorAgreementSignatureRequiredModel != null &&
                $ctrl.masterAdvisorAgreements.length === 0) {

                if ($ctrl.envelopeId != null) {                
                    if ($location.search().event === "signing_complete") {
                        $ctrl.docIsigned = true;

                        var envelopeData = { DocusignEnvelopeId: $ctrl.envelopeId }
                        agreementsApi.createMasterAdvisorAgreement(envelopeData).then(function(result) {
                            console.log(result);
                            //$state.go("Home.Dashboard");
                            $state.go("Home.Dashboard", {}, { reload: true });
                        });
                    }
                }              
            } else {
               
                if (!$ctrl.UI.testing)
                    $state.go("Home.Dashboard");                   
            }                
        };

        $ctrl.downloadPdfByArcAgentId = function (arcAgentId) {           
            agreementsApi.getgetMasterAdvisorAgreementPdfByArcAgentId(arcAgentId).then(function (pdf) {
                console.log(pdf);
                var fUrl = $window.URL.createObjectURL(pdf);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function () {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        }

        $ctrl.downloadPdf = function (agreement) {

            agreementsApi.getgetMasterAdvisorAgreementPdf(agreement.Id).then(function (pdf) {
                console.log(pdf);
                var fUrl = $window.URL.createObjectURL(pdf);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function () {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        }

        $ctrl.downloadXml = function (agreement) {

            agreementsApi.getgetMasterAdvisorAgreementXml(agreement.Id).then(function (xml) {
                console.log(xml);
                var fUrl = $window.URL.createObjectURL(xml);
                $window.open(fUrl);
                $scope.$on("$destroy",
                    function () {
                        $window.URL.revokeObjectURL(fUrl);
                    });
            });
        }        
                                                             
        $ctrl.createAgreement = function () {
            $ctrl.redirecting = true;
            agreementsApi.initMasterAdvisorAgreement().then(function(result) {
                console.log(result);
                $window.location.href = result;
            },
            function error(x) {
                console.log(x);
                $ctrl.signError = true;
                $ctrl.redirecting = false;               
            });
        }

        $ctrl.removeAgreement = function (agreement) {         
            agreementsApi.removeMasterAdvisorAgreement(agreement.Id).then(function (result) {
                console.log(result);   

                ng.forEach($ctrl.masterAdvisorAgreements, function (agmt, index) {
                    if (agreement.Id === agmt.Id)
                        $ctrl.masterAdvisorAgreements.splice(index, 1);
                });
            },
            function error(x) {
                console.log(x);                   
            });
        }

        $ctrl.tempOptOut = function() {
            permissionService.setOptOutMasterAdvisorAgreement();
        }

        init();

    }
})(window.app, window.angular); // jshint ignore:line